import { NgModule } from "@angular/core";

import { CallService } from "app/services/call.service";
import { ProblemTemplateService } from "app/services/problemTemplate.service";
import { AuthenticationService } from "app/services/authentication.service";
import { ProfileService } from "app/services/profile.service";
import { HttpBackendService } from "app/services/http-backend.service";
import { VersionService } from "./version.service";
import { LocationService } from "app/services/location.service";
import { AssetService } from "app/services/asset.service";
import { PlannedServiceService } from "app/services/plannedService.service";
import { FileStorageService } from "app/services/fileStorage.service";
import { ServiceAreaService } from "./serviceArea.service";
import { UserService } from './user.service';
import { NotificationService } from "./notification.service";
import { ApplicationSettingsService } from "./applicationSettings.service";
import { ScrollToAnchorService } from './scroll-to-anchor.service';
import { ServiceObjectService } from "./serviceObject.service";

@NgModule({
    declarations: [],
    imports: [],
    providers: [
      CallService,
      PlannedServiceService,
      ProblemTemplateService,
      FileStorageService,
      ServiceAreaService,
      LocationService,
      AssetService,
      AuthenticationService,
      ProfileService,
      VersionService,
      HttpBackendService,
      UserService,
      NotificationService,
      ApplicationSettingsService,
      ScrollToAnchorService,
      ServiceObjectService
    ]
})
export class ServiceModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/services/service.module.ts